import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  aside: {
    padding: '1rem 1rem 0.5rem',
    marginInline: '-1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    backgroundColor: neutral[10],
  },
  title: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
  btn: {
    padding: '0.75rem 0rem',
    justifyContent: 'space-between',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
  },
});
